import { generateHelpers } from '@lokalise/styled';

import themes from '../themes';

export const {
    color,
    spacing,
    font,
    radius,
    transition,
    typography,
    zIndex,
    boxShadow,
    mediaQuery,
    breakpoints,
    value,
    valueFromProp,
} = generateHelpers(themes.baseTheme, { objectKeys: ['typography'] });

/**
 * @deprecated use these directly from `@lokalise/styled`
 */
export { modifier, variants } from '@lokalise/styled';
